(function($) {
	$(document).ready( function() {

		$('.app-menu').on('click', '.menu-item-has-children', function() {
			$(this).toggleClass('active');
		});
		/* @LINK: https://stackoverflow.com/a/52921770 */
		if( $('#testimonial-controls').length ) {
			var carousel_length = $('#testimonial-controls .carousel-item').length - 1;
			$('#testimonial-controls').on('slide.bs.carousel', function (e) {
				// First one
			    if (e.to == 0) {
			        $('.carousel-control-prev').addClass('active');
			        $('.carousel-control-next').removeClass('active');
			    } // Last one
			    else if (e.to == carousel_length) {
			        $('.carousel-control-prev').removeClass('active');
			        $('.carousel-control-next').addClass('active');
			    } // The rest
			    else {
			        $('.carousel-control-prev').removeClass('active');
			        $('.carousel-control-next').removeClass('active');
			    }
			});
		}

		$.fn.isInViewport = function() {
			var elementTop = $(this).offset().top;
		    //var elementBottom = elementTop + $(this).outerHeight();
		    var elementHeight = $(this).outerHeight();

		    var viewportTop = $(window).scrollTop();
		    //var viewportBottom = viewportTop + $(window).height();
		    var viewportHeight = $(window).height();

		    //return elementBottom > viewportTop && elementTop < viewportBottom;
		    return viewportTop + (viewportHeight/2) >= (elementTop);
		};

		/* 
		 * play video and animation once element come in view port
		 * @LINK: https://stackoverflow.com/a/40658647
		 */
		if( $('.visible-on-scroll').length ) {

			circle = $('#circle');
			if( circle.length ) {
				circle.circleProgress({
					value: 0,
					size: 150,
					thickness: 7,
					fill: "#0070c0",
					startAngle: -Math.PI*1.7,
					animation: { duration: 12000, easing: "linear" }
				}).on('circle-animation-progress', function (event, progress, stepValue) {
		            $(this).find('strong').text(Math.round(stepValue * 100) + '%');
		        });
			}

			$(window).on('scroll', function() {
				if ( $('.visible-on-scroll:not(.activated)').length ) {
					if ( $('.visible-on-scroll').isInViewport() ) {
				        $('.visible-on-scroll').addClass('activated');
				        $('.visible-on-scroll').find('video').get(0).play();

				        if( circle.length ) {
				        	circle.circleProgress({ 
				        		value: 0.85 
				        	});
				        }
				    }
			    }
			});
		}

		if( $('.expandable-wrapper').length ) {
			$('.expandable-btn').on('click', function(e) {
				e.preventDefault();

				$(this).closest('.expandable-wrapper').toggleClass('active');
			});
		}

		// Disable animation effect for tab widget : Elementor
		// @LINK: https://github.com/elementor/elementor/issues/12724#issuecomment-704338816
		$(window).on('load', function() {
		    // Unbind default Elementor behaviour
		    $('.elementor-widget-tabs .elementor-tab-title').off('click keydown');

		    $('.elementor-widget-tabs .elementor-tab-title').on('click', function(e) {
		        e.preventDefault();
		    
		        var $this = $(this);
		        var $widget = $this.closest('.elementor-widget-tabs');
		        
		        // Tab title
		        var $tabTitle = $('.elementor-tab-title', $widget);
		        $tabTitle.removeClass('elementor-active');
		        $this.addClass('elementor-active');
		        
		        // Tab content
		        var $tabContent = $('.elementor-tab-content', $widget);
		        $tabContent.hide();
		        $tabContent.filter('[data-tab="' + $this.data('tab') + '"]').show();
		    }); 
		});

	});
})(jQuery);